<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import ImageSkeleton from "@components/skeletons/ImageSkeleton.svelte";
</script>

<div>
    <div class="gw-wl-item-skeleton">
        <div class="gw-wl-item-skeleton-image">
            <ImageSkeleton ratio={1 / 1} />
        </div>
        <div class="gw-wl-item-skeleton-content">
            <div class="gw-wl-item-skeleton-title">
                <BaseSkeleton width="100%" />
                <BaseSkeleton width="70%" />
            </div>

            <BaseSkeleton />
            <BaseSkeleton />

            <div>
                <BaseSkeleton width="90%" height="30px" pill />
            </div>
        </div>
    </div>
</div>

<style>
    .gw-wl-item-skeleton {
        display: flex;
        position: relative;
        align-items: center;
        padding: 1em 0.5em;
        column-gap: 10px;
    }

    .gw-wl-item-skeleton-image {
        width: 140px;
        height: 140px;
        overflow: hidden;
        flex-shrink: 0;
    }

    .gw-wl-item-skeleton-content {
        width: 100%;
    }

    .gw-wl-item-skeleton-title {
        width: 100%;
        font-size: 0.9em;
        font-weight: 600;
        line-height: 1em;
    }
</style>
